<template>
  <home />
</template>

<script>
import home from "./components/home.vue";

export default {
  components: {
    home,
  },
};
</script>

<style></style>
